import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LocationService } from './service/location.service';
import { AuthorizationService } from './service/authorization.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [
    AuthorizationService,
    LocationService
  ]
})
export class SharedModule {
}
